/** 登录 */
export default {
  label: {
    code: '手机登录&注册',
    pswd: '密码登录'
  },
  phone: '手机号码',
  password: '登录密码',
  code: '{type}验证',
  sms: '短信',
  img: '图形',
  getCode: '获取验证码',
  login: '登 录',
  // 选择商户
  choose: '选择商户',
  // 提示
  agree: '未注册的手机号将自动注册。勾选即代表您同意并接受',
  agreement: '《商户平台用户协议》',
  second: '秒',
  // 微信登录
  wx: '微信登录',
  // 活动管理平台
  activity_platform: {
    title: '活动管理平台',
    subtitle: '由简到繁，无穷的变化及设置，满足您的活动需求',
    features: [
      '通过-多个轮次，多个分类分组组合发布大型活动',
      '通过-人气榜单为您的活动增加曝光量',
      '通过-加载广告实现多形式推广',
      '通过-多维度的评选，精准选出最佳的参加者',
      '通过-图片、视频的上传展现出缤纷多彩的现场'
    ]
  },
  // 评选晋级
  evaluation: {
    title: '评选晋级',
    subtitle: '多维度评选实现最为公平正式的选拔评分',
    features: [
      '创建多维度的评分方案赋予不同的组别，复合式选拔',
      '评分、评判两种评选方式供您选择',
      '多评委同时评选、评分，实现公平的权威性',
      '学员评选成绩筛选；晋级、淘汰一键式操作',
      '创建奖状名次赋予优秀的学员'
    ]
  },
  // 精彩时刻
  moments: {
    title: '精彩时刻',
    subtitle: '图片、视频记录活动中的精彩时刻瞬间',
    features: [
      '上传图片或者视频，发布在手机端作为各方精彩时刻的留念',
      '通过标签，分类不同的图片和视频，形成有效的管理',
      '图片及视频的下载可让用户永久保留住高光时刻'
    ]
  },
  // 人气榜单
  popularity: {
    title: '人气榜单',
    subtitle: '活动热度通过榜单排名完美体现',
    features: [
      '点赞榜单，一人一票展现出活动的高人气印象',
      '礼物榜单，为您所支持的人气选手做出一份贡献',
      '多阶段榜单，展现出活动各个阶段不同的人气',
      '多组别榜单。展现出不同组别的高人气学员'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/zh_cn/login.js